<template>
  <div class="full-area">
    <header class="question-header" v-if="!(data.fields.questionImage && data.fields.questionImage.fields.file.url)">
      <h2>{{data.fields.title}}</h2>
      <p class="help-text" v-if="data.fields.helpText">{{data.fields.helpText}}</p>
    </header>

    <header class="question-header image-question contain-image"
      v-if="data.fields.questionImage && data.fields.questionImage.fields.file.url"
    >
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>

    </header>

    <content class="content delay-entry">
      <div
        :style="{backgroundColor: colorList[originalArray.indexOf(item)]}"
        class="list-item"
        v-for="item in items" v-dragging="{ item: item, list: items, group: 'item' }"
        :key="item"
      >{{item}}</div>
    </content>

    <SkipQuestionButton
      :disable-submit-button="disableSubmit"
      :show-submit="true"
      v-on:skip="skipQuestion()"
      v-on:submit="submitQuestion()"
    ></SkipQuestionButton>
  </div>
</template>

<script>
import chroma from 'chroma-js'
var randomColor = require('randomcolor')

export default {
  name: 'Slider',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      disableSubmit: true,
      colorList: [],
      hueList: ['green', 'red', 'orange', 'blue'],
      items: this.data.fields.list.sort(function () { return 0.5 - Math.random() }),
      originalArray: this.data.fields.list.slice(),
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        selected: null,
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      timer: null
    }
  },

  computed: {
    chromaList () {
      return chroma.scale(['#88d8b0', '#f56c6c']).mode('lch').colors(this.items.length)
    }
  },

  methods: {
    skipQuestion () {
      this.form.selected = ['NS/NR']
      this.next()
    },
    submitQuestion () {
      this.form.selected = this.items
      this.next()
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.form.timestamps.valid = new Date()
      this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      this.$emit('next', this.form)
    }
  },

  mounted () {
    setTimeout(() => {
      this.disableSubmit = false
    }, 3500)

    this.colorList = randomColor({
      count: this.items.length,
      hue: this.hueList[Math.floor(Math.random() * this.hueList.length)],
      format: 'rgba',
      alpha: 0.3
    })
  }
}
</script>

<style scoped lang="scss">
  .question-header {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    max-height: 30vh;
  }
  .content {
    margin-bottom: 60px;
    margin-top: -60px;
    flex-direction: column;
  }
  .help-text {
    color: $gray-medium;
    padding: 0 10px;
  }
  .list-item {
    transition: all 0.2s ease-in-out;
    font-size: 1.4em;
    line-height: 1.5;
    background-color: #f0f0f0;
    border: 1px solid #c0c0c0;
    width: 70%;
    margin-bottom: 3px;
    border-radius: 8px;

    @include breakpoint($micro) {
      font-size: 1.1em;
      line-height: 1.3;
    }
    @include breakpoint($tablet) {
      font-size: 1.2em;
      margin-bottom: 6px;
      width: 50%;
    }
    @include breakpoint($desktop) {
      font-size: 1.2em;
      line-height: 1.7;
      width: 70%;
    }

    &.dragging {
      background-color: #c0c0c0;
      transform: scale(1.1);
      animation: shakeIt 0.8s ease-in-out infinite;
    }
  }
  .button-wrapper {
    margin-top: 30px;
  }
</style>
